<template>
    <div>
        <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            staticMode="true"
        >
        </TopAppBar>

    <div id="tab1" class="t-color-content1 pdt-16 pdb-18">
        <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
            <div>
                <button
                    class="t-helper t-color-white bg-dark d-inline-block mgr-4 pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36
                    font-r">계정 관리</button>
                <button
                    class="t-helper t-color-white bg-blue1 d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36
                    font-r">로그인 또는 로그아웃</button>
            </div>
            <div class="t-headline7 t-color-title l-spacing6 pdt-10 pdb-8 font-m">비밀번호 변경 또는 재설정</div>
            <div class="t-body3 t-color-content1 l-spacing42 font-r">보안 상의 이유로 비밀번호를 변경하거나 잊어버린 경우 재설정할 수 있습니다.<br>
                <a href="https://www.google.com/search?source">https://www.google.com/search?source</a></div>
            <div class="pdt-24">
                <button
                    class="t-helper t-color-blue3 bg-gray d-flex align-items-center pdt-5 pdb-5 pdl-4 pdr-4 b-radius2 mgb-4 font-r font-11"><i
                        class="material-icons font-16 pdr-8">attach_file</i>첨부파일은 이미지만 등록.png</button>
            </div>
        </div>
        <div class="pdt-16"><img src="images/helpdesk/dummy_image.png" alt="" class="attachedImage"></div>


    </div>
    </div>
</template>

<script>
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
export default {
    components: {
        TopAppBar,
    },

    mixins: [topAppBarMixin],

    watch: {
        '$route' (to, from) {
            
        }
    },

    mounted() {
        //this.setTopAppBarHomeBlank(this.$t('66'))
        this.setTopAppBarBackSearch(this.$t('1501'))
    },
}
</script>
<style scoped>
.nav-extended .brand-logo,
        .nav-content * {
            font-family: noto-regular;
        }

        .nav-extended .brand-logo {
            font-size: 20px;
            letter-spacing: -0.6;
        }

        .tabs .tab a:focus,
        .tabs .tab a:focus.active {
            background-color: #F5F5F5;
            outline: none;
        }

        .tabs .indicator {
            background: #2d6dcc;
        }

        .mdc-elevation--z3 {
            border-radius: 4px;
            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
            background-color: #ffffff;
        }


        .b-radius2 {
            border-radius: 2px;
        }

        .l-spacing36 {
            letter-spacing: -0.36px;
        }

        .font-16 {
            font-size: 16px;
        }

        .bg-blue3 {
            background-color: #80aed4
        }
        .attachedImage{
            height: 356px;
            object-fit: cover;
        }
        .font-11{
            font-size: 11px !important;
        } 
</style>